import parsePhoneNumber from 'libphonenumber-js';

export interface PhoneUtils {
  formatPhoneNumber: (phoneNumber: string) => string | null;
}

// @ts-ignore
angular
  .module('utils')
  .factory(
    'PhoneUtils',
    (): PhoneUtils => ({
      formatPhoneNumber: (phoneNumber: string) => {
        const parsedPhoneNumber = parsePhoneNumber(phoneNumber, 'US');
        if (!parsedPhoneNumber) {
          return null;
        }

        const formattedPhoneNumber = parsedPhoneNumber.formatInternational();
        return formattedPhoneNumber.replaceAll(' ', '');
      },
    }),
  );
